import constants from "../constants";

export default {
  loading: false,
  showModalTakeAwayLess: false,
  category_uuid: '',
  categoryList: null,
  sub_category_uuid: '',
  coupon_message: '',
  menu_deal: {},
  selectedCategory: null,
  attributeList: null,
  attributeFilter: null,
  selectedSubCategory: null,
  selectedProduct: null,
  selectedCart: null,
  selectedOrderTime: null,
  selectedOutlet: null,
  selectedHutOutletId: null,
  selectedHutOutlet: null,
  selectedDisposition: null,
  isValidOrderTime: true,
  paymentStatus: false,
  user: null,
  lang: constants.LANG_EN,
  sidebarOpen: false,
  shouldTriggerChoosingTopping: false,
  selectedSizeCrust: {
    size: {},
    crust: {},
  },
  extraToppings: [],
  defaultToppings: [],
  addedExtraToppings: [],
  removedDefaultToppings: [],


  /**
   * Half & Half
   */
  hhSizes: [],
  hhCrustes: [],
  hhSelectedSizeCrust: {
    size: {},
    crust: {},
  },

  hhLeftPizza: {},
  hhRightPizza: {},
  hhPizzaList: [],

  // H&H LEFT pizza
  pzzLeftExtraToppings: [],
  pzzLeftDefaultToppings: [],
  pzzLeftAddedExtraToppings: [],
  pzzLeftRemovedDefaultToppings: [],

  // H&H RIGHT pizza
  pzzRightExtraToppings: [],
  pzzRightDefaultToppings: [],
  pzzRightAddedExtraToppings: [],
  pzzRightRemovedDefaultToppings: [],
  hutReward: {},
  maintainanceHutReward: {},
  slicesReward: {
    addMore: 1000,
    current: 0
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js